import React from "react";
import { useAuth } from "@/AuthContext";
import api from "@/api";
import AnnouncementPopup from "@/components/AnnouncementPopup";
import {
  dismissAnnouncement,
  isAnnouncementDismissed,
} from "@/utils/announcementSession";

export default function AnnouncementChecker() {
  const { user, ready } = useAuth();
  const [queue, setQueue] = React.useState({ userId: null, items: [], index: 0 });
  const requestId = React.useRef(0);

  React.useEffect(() => {
    const currentRequest = ++requestId.current;
    const userId = user?.id;
    setQueue({ userId, items: [], index: 0 });
    if (!ready || !user?.id) {
      return undefined;
    }

    let cancelled = false;
    api.get("/announcements/active")
      .then(({ data }) => {
        if (cancelled || requestId.current !== currentRequest) return;
        const items = Array.isArray(data?.items) ? data.items : [];
        setQueue({
          userId, index: 0,
          items: items.filter(item => item?.id && !isAnnouncementDismissed(userId, item.id)),
        });
      })
      .catch(() => {
        // Announcements are non-critical; don't interfere with normal login.
        if (!cancelled && requestId.current === currentRequest) setQueue({ userId, items: [], index: 0 });
      });

    return () => { cancelled = true; };
  }, [ready, user?.id]);

  const current = queue.userId === user?.id ? queue.items[queue.index] : null;

  const dismissCurrent = React.useCallback(() => {
    if (!current || !user?.id) return;
    dismissAnnouncement(user.id, current.id);
    setQueue(state => state.userId === user.id && state.items[state.index]?.id === current.id
      ? { ...state, index: state.index + 1 } : state);
  }, [current, user?.id]);

  if (!ready || !current) return null;
  return (
    <AnnouncementPopup
      announcement={current}
      index={queue.index}
      total={queue.items.length}
      onClose={dismissCurrent}
    />
  );
}
